module.exports = __webpack_public_path__ + "img/temp_left.3cc7a6e3.png";